var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLargeRoundedShare = function SvgLargeRoundedShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.375 8.938h.875c.966 0 1.75.783 1.75 1.75v8.75a1.75 1.75 0 0 1-1.75 1.75H6.75A1.75 1.75 0 0 1 5 19.438v-8.75c0-.967.784-1.75 1.75-1.75h.875a.875.875 0 1 1 0 1.75H6.75v8.75h10.5v-8.75h-.875a.875.875 0 0 1 0-1.75m-5.04-5.82a.873.873 0 0 1 1.33 0l2.429 2.43a.875.875 0 0 1-1.238 1.237l-.981-.981v8.384a.875.875 0 0 1-1.75 0V5.804l-.981.98a.875.875 0 1 1-1.238-1.237z"
  })));
};
export default SvgLargeRoundedShare;